import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import styles from '../../../styles/style-setting.module.scss';

const EditUnit = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateUnitModal, setUpdateUnitModal] = useState(false);
  const [unitData, setUnitData] = useState({});
  const [OpenAlert, setOpenAlert] = useState(false);
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [, setUnitName] = useState('');
  const [, setUnitDescription] = useState('');
  const [, setUnitValue] = useState('');
  const [spinner, setSpinner] = useState(false);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...unitData };
    item[name] = value;
    setUnitData(item);
    
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (
        unitData['name'] === '' ||
        unitData['value'] === '' ||
        (unitData['name'] === '' && unitData['value'] === '')
      ) {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        restFields();
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        const response = httpClient.current?.put(`/api/unit/update`, unitData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.units();
          setUpdateUnitModal(!UpdateUnitModal);
        }
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    restFields();
    setUpdateUnitModal(!UpdateUnitModal);
  };

  const restFields = () => {
    unitData['name'] = props.unit['name'];
    unitData['value'] = props.unit['value'];
  };

  const handleCancel = () => {
    setUpdateUnitModal(!UpdateUnitModal);
  };

  useEffect(() => {
    setUnitData(props.unit);
  }, [props.unit]);
  return (
    <>
      <EditButtonIcon
        title={props.t('update_unit')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateUnitModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_unit')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <label htmlFor={'unit_name'}>{props.t('unit_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="unit_name"
                    value={unitData['name']}
                    onChange={(e) => setUnitName(e.target.value)}
                    placeholder={props.t('enter_unit_name')}
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="unit_description">{props.t('Description')}</label>
                  <textarea
                    value={unitData['description']}
                    name="description"
                    className="form-control"
                    id="unit_description"
                    onChange={(e) => setUnitDescription(e.target.value)}
                    rows={3}
                    placeholder={props.t('more_details')}
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="unit_value">{props.t('unit_value')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="value"
                    id="unit_value"
                    value={unitData['value']}
                    onChange={(e) => setUnitValue(e.target.value)}
                    placeholder={props.t('enter_unit_value')}
                  />
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={handleCancel}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditUnit);
